export default __webpack_public_path__ + "static/media/spaghetti.1227c879.webp";